// extracted by css-extract-rspack-plugin
export default {"searchContainer":"searchContainer-rmLOMT"};